import { List } from '@mui/material';
import React, { FC } from 'react';

import NavigationLink from '../../../../interfaces/NavigationLink';
import { classnames } from '../../../../utils';
import SidebarListItem from '../SidebarListItem/SidebarListItem';
import styles from './SidebarList.module.scss';

interface SidebarListProps {
  list: NavigationLink[];
  isParentElement?: boolean;
  onCloseSidebar: () => void;
  onActive: (content: NavigationLink) => void;
}

const navItemWeight = (item: NavigationLink): number => {
  if (item.comingSoon) return 3;
  if (item.notSubscribed) return 2;
  if (item.locked) return 1;
  return 0;
};

const SidebarList: FC<SidebarListProps> = ({
  list,
  isParentElement = false,
  onCloseSidebar,
  onActive,
}) => {
  const orderedList = [...list].sort(
    (a, b) => navItemWeight(a) - navItemWeight(b)
  );

  return (
    <List
      id={styles.sidebarList}
      className={classnames({ [styles.parentElement]: isParentElement })}
    >
      {orderedList.map((navListItem) => (
        <SidebarListItem
          key={navListItem.label}
          {...navListItem}
          onActive={onActive}
          onCloseSidebar={onCloseSidebar}
          isParentElement={isParentElement}
        />
      ))}
    </List>
  );
};

export default SidebarList;
